import { FC } from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.scss';

export const HeaderMain: FC = () => {
  return (
    <header className={styles['header']}>
      <div className={styles['header__inner']}>
        <Link to={'/main'} className={styles['header__logo']}>
          <img
            className={styles['logo__image']}
            src="/assets/svg/logo.svg"
            alt="Логотип КапиПары"
          />
        </Link>
        {/* <Link to={'#'} className={styles['header__user']}>
          <img
            className={styles['user__icon']}
            src="/assets/svg/user-icon.svg"
            alt="Изображение пользователя"
          />
        </Link> */}
      </div>
    </header>
  );
};
